export default __webpack_public_path__ + "static/media/bruce-mars.8a606c4a.jpg";